import _ from "lodash";
import React from "react";
import { resolveRowColValue } from "utils/dataViews";
import key from "weak-key";

interface Props {
  row: any;
  index: number;
  selectedIdColumns: string[];
}

export default function DataViewQueryResultTableRow({ row, index, selectedIdColumns }: Props): JSX.Element {
  return (
    <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
      {Object.keys(row).map((col) => {
        return (
          <td
            key={key({ col })}
            className={`text-gray-900 border-y border-y-gray-200 
                ${_.includes(selectedIdColumns, col) ? "bg-blue-50" : null}`}
          >
            <div className="show-scrollbar text-sm p-2 break-all min-w-fit max-h-20 overflow-y-auto">{resolveRowColValue(row[col])}</div>
          </td>
        );
      })}
    </tr>
  );
}
